import * as React from "react";
import { SocketContext } from "../socket/SocketContextProvider";

export function useSocketContext() {
  return React.useContext(SocketContext);
}
